function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Contacts_svg__15_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#D576F0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Contacts_svg__15_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("path", {
  fill: "#F4E3FE",
  fillRule: "nonzero",
  d: "M32 11a2 2 0 011.995 1.85L34 13v1.551a.5.5 0 00.4.489 2 2 0 011.593 1.794L36 17v20a2 2 0 01-1.85 1.995L34 39H17a3 3 0 01-2.995-2.824L14 36V14a3 3 0 012.824-2.995L17 11h15zm-6.98 10l-.175.004c-1.64.087-2.902 1.506-2.816 3.17a5.35 5.35 0 001.126 3.66c.093.247.095.519.008.767l-.568.218c-1.719.673-2.688 1.213-3.096 2.043-.089.183-.18.491-.275.924a1 1 0 00.86 1.207L20.2 33h9.6a1 1 0 00.976-1.215l-.08-.337a3.307 3.307 0 00-.194-.58c-.451-.922-1.588-1.485-3.647-2.253a1.08 1.08 0 01-.026-.755 5.374 5.374 0 001.143-3.686c.005-.105.005-.21 0-.315-.083-1.604-1.387-2.85-2.952-2.859zm6.73-8H17a1 1 0 00-.117 1.993L17 15h14.75a.25.25 0 00.243-.193L32 14.75v-1.5a.25.25 0 00-.193-.243L31.75 13z"
}));

var SvgContacts = function SvgContacts(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgContacts;